import React, {useState} from 'react';
import CommonModal, {ICommonModal} from 'components/common/CommonModal';
import styled from 'styled-components';

import SelectPlan from './SelectPlan';
import {ISubscriptionProduct} from 'interfaces/interface';
import TossPayment from 'components/common/TossPayment';

/**
 * 플랜 구독 모달 컴포넌트의 Props 인터페이스
 * @property {any[] | null} plansData - 플랜 데이터 목록
 */
interface IProps extends ICommonModal {
  plansData: any[] | null;
}

/**
 * 플랜 구독 모달 컴포넌트
 * 플랜을 구독하는 모달 컴포넌트입니다.
 * @param {IProps} props - 플랜 구독 모달 컴포넌트의 props
 * @returns {JSX.Element} 플랜 구독 모달 컴포넌트
 */
export default function SubscribePlanModal({
  title,
  closeModal,
  plansData,
}: IProps) {
  const [step, setStep] = useState(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [basicPlan, setBasicPlan] = useState<ISubscriptionProduct>();

  const modalStep = [
    <SelectPlan
      closeModal={closeModal}
      key={0}
      setStep={setStep}
      plansData={plansData}
      totalAmount={totalAmount}
      setTotalAmount={setTotalAmount}
      basicPlan={basicPlan}
      setBasicPlan={setBasicPlan}
    />,
    <TossPayment key={1} totalAmount={totalAmount} basicPlan={basicPlan} />,
  ];

  return (
    <CommonModal closeModal={closeModal}>
      <Container>{modalStep[step]}</Container>
    </CommonModal>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;
